import styles from './ExternalLinkIcon.module.css';

/**
 * External-link indicator — renders an inline SVG arrow leaving a
 * box. Used on anchors that open in a new tab (task 139 issue rows
 * pointing at Jira). Inherits current text color so it sits correctly
 * inside the link.
 *
 * Always `aria-label="opens in a new tab"` — the accessible name is
 * required (the surrounding anchor may not speak to the "new tab"
 * behavior on its own).
 */
export function ExternalLinkIcon({ size = 12, className }: { size?: number; className?: string }) {
  return (
    <svg
      className={`${styles.icon} ${className ?? ''}`}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-label="opens in a new tab"
      role="img"
    >
      {/* Box body */}
      <path d="M6.5 2.5h-3A1.5 1.5 0 0 0 2 4v8.5A1.5 1.5 0 0 0 3.5 14H12a1.5 1.5 0 0 0 1.5-1.5v-3" />
      {/* Arrow going out of the top-right corner */}
      <path d="M8 8l6-6" />
      <path d="M10 2h4v4" />
    </svg>
  );
}
